exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".echart03[data-v-2d9b1bf4]{font-size:10px;font-weight:700;width:90%;margin:0 5%}", ""]);

// exports
